var ScrollbarSkins;
(function (ScrollbarSkins) {
    ScrollbarSkins["Accent"] = "accent";
    ScrollbarSkins["Control"] = "control";
})(ScrollbarSkins || (ScrollbarSkins = {}));

export { ScrollbarSkins };
